import _default from './List';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/elements/List/index.js
// module id = 872
// module chunks = 0